/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, memo } from 'react'
import Grid from '@material-ui/core/Grid'
import Avatar from '@material-ui/core/Avatar'
import Chip from '@material-ui/core/Chip'
import Fab from '@material-ui/core/Fab'
import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import InputBase from '@material-ui/core/InputBase'
import Paper from '@material-ui/core/Paper'
import SaveIcon from '@material-ui/icons/Save'
import CancelIcon from '@material-ui/icons/Cancel'
import { permitsList, minPermisos, generalTitles } from '@auteco/constants'
import PolygonsTable from 'src/components/sharedComponents/Tablas/index'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import PoperComponent from 'src/components/sharedComponents/Popover'
import useInputValue from 'src/utils/hooks/useInputValue'
import Card from 'src/components/sharedComponents/Card/Card'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import Search from 'src/components/sharedComponents/SearchInput'
import canUseState from 'src/utils/canUseState'
import { useStyles } from './styles'

const ManagerPage = (props) => {
  const {
    bosses = [],
    manager = [],
    managerBosses = [],
    searchManager,
    search,
    select,
    permisos,
    onCreateManager,
    hadleSearchManager,
    handleDeleteTable,
    handleCreate,
    handleSearch,
    handleDelete,
    handleSelect,
    handleUpdate,
  } = props

  const classes = useStyles()
  const inputValue = useInputValue('')
  const inputEdit = useInputValue('')
  const [edit, setEdit] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const create = open ? 'simple-popover' : undefined

  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(!anchorEl)
  }

  const onCreate = (event) => {
    event.preventDefault()
    setAnchorEl(null)
    onCreateManager({
      value: inputValue.value,
    })
  }

  const onUpdate = (event) => {
    event.preventDefault()
    setAnchorEl(null)
    setEdit(!edit)
    handleUpdate({
      nombre: inputEdit.value,
      id: select?.id,
      // unidad_negocio_id: managerBosses[0]?.unidad_negocio_id
    })
  }

  const columnsPolygonsManagers = [
    { title: 'Gerente', field: 'gerente' },
    { title: 'Gerente_id', field: 'gerente_id', hidden: true },
    { title: 'Jefe', field: 'jefe' },
    { title: 'Jefe_id', field: 'jefe_id', hidden: true },
    { title: 'Unidad N', field: 'unit', hidden: true },
  ]

  return (
    <>
      <CardTitle
        title={generalTitles.TITLE_MANAGER}
        subTitle={generalTitles.SUB_TITLE_CARD}
      />
      <div className={classes.root}>
        <Grid container spacing={1}>
          {/*= ========================================================================
            Lista de TerritorioS
            ======================================================================== */}
          <Card>
            <CardHeader>
              <Grid container>
                <Grid item xs={12} sm={5}>
                  <h3>{generalTitles.TITLE_MANAGER}</h3>
                  <p>Seleccione un gerente</p>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Tooltip
                    title={`${generalTitles.ADD} ${generalTitles.MANAGER}`}
                    aria-label="add"
                  >
                    <Fab
                      onClick={handleOpenPopover}
                      size="medium"
                      color="primary"
                      aria-label="add"
                    >
                      <AddIcon />
                    </Fab>
                  </Tooltip>
                  <PoperComponent
                    handleUpdate={onCreate}
                    handleClose={handleClose}
                    inputValue={inputValue}
                    className={classes.popover}
                    anchorEl={anchorEl}
                    title="Nuevo territorio"
                    open={open}
                    id={create}
                  />
                </Grid>
              </Grid>
              <Search handleSearch={handleSearch} search={search} />
            </CardHeader>
            <CardBody className={classes.cardBody}>
              {manager &&
                manager?.map((item) => (
                  <div key={item.id}>
                    <Chip
                      id={item.id}
                      label={item.nombre.toUpperCase()}
                      clickable
                      className={classes.chip}
                      color="primary"
                      deleteIcon={
                        <DeleteIcon
                          className={classes.tableActionButtonIcon}
                          style={{ color: '#f44336 ' }}
                        />
                      }
                      variant="outlined"
                      onDelete={
                        permisos[permitsList.ADMIN_GERENTES] >=
                        minPermisos.ELIMINAR
                          ? handleDelete(item)
                          : null
                      }
                      onClick={
                        permisos[permitsList.ADMIN_GERENTES] >=
                        minPermisos.CREAR
                          ? handleSelect(item)
                          : null
                      }
                    />
                  </div>
                ))}
            </CardBody>
          </Card>
          {/*= ========================================================================
            Lista de zonas
            ======================================================================== */}
          <Card>
            <CardHeader>
              <Grid container>
                <Grid item sm={6}>
                  <h3>{generalTitles.BOSSES}</h3>
                </Grid>
                <Grid item sm={6}>
                  {select && (
                    <>
                      <p>{generalTitles.BOSSES} seleccionado</p>
                      <Chip
                        avatar={<Avatar>J</Avatar>}
                        label={select.nombre}
                        clickable
                        className={classes.chip}
                        color="primary"
                        deleteIcon={
                          <EditIcon
                            className={classes.tableActionButtonIcon}
                            style={{ color: ' #4CAF50' }}
                          />
                        }
                        variant="outlined"
                        style={{ width: '100%' }}
                        onClick={() => setEdit(!edit)}
                        onDelete={
                          permisos[permitsList.ADMIN_GERENTES] >=
                          minPermisos.ACTUALIZAR
                            ? () => setEdit(!edit)
                            : null
                        }
                      />
                      {edit && (
                        <Paper
                          component="form"
                          onSubmit={onUpdate}
                          className={classes.paper}
                        >
                          <InputBase
                            className={classes.input}
                            placeholder={select.nombre}
                            inputProps={{ 'aria-label': `${select.nombre}` }}
                            {...inputEdit}
                          />
                          <IconButton
                            type="submit"
                            className={classes.iconButton}
                            aria-label="search"
                          >
                            <SaveIcon />
                          </IconButton>
                          <IconButton
                            type="onClick"
                            onClick={() => setEdit(!edit)}
                            className={classes.iconButton}
                            aria-label="search"
                          >
                            <CancelIcon />
                          </IconButton>
                        </Paper>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
              <Search
                handleSearch={hadleSearchManager}
                search={searchManager}
              />
            </CardHeader>
            <CardBody className={classes.cardBody}>
              {bosses &&
                bosses?.map((item) => {
                  const canUse = canUseState(
                    managerBosses,
                    item,
                    'jefe_id',
                    'id',
                  )
                  return (
                    <div key={item.id}>
                      <Chip
                        avatar={
                          <Avatar className={classes.avatar}>
                            {item.nombre.charAt(0)}
                          </Avatar>
                        }
                        label={item.nombre.toUpperCase()}
                        clickable
                        className={classes.chip}
                        color={!canUse ? 'default' : 'primary'}
                        onClick={handleCreate({
                          jefe_id: item.id,
                          gerente_id: select.id,
                        })}
                        disabled={!select}
                      />
                    </div>
                  )
                })}
            </CardBody>
          </Card>
        </Grid>
      </div>
      {/*= =======================================================================
        Tabla Territorios
        ======================================================================== */}
      <PolygonsTable
        columns={columnsPolygonsManagers}
        dataTable={managerBosses}
        idPermisoTabla={permitsList.ADMIN_GERENTES_JEFES}
        onDeleteTable={handleDeleteTable}
        titleTable={generalTitles.TITLE_TABLE_MANAGERS}
        hiddenEdit
        hiddenDelete={false}
      />
    </>
  )
}

export default memo(ManagerPage)
